import styled, { DefaultTheme, css } from 'styled-components';

type TextProps = {
  color?: keyof DefaultTheme['colors'];
};

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;

  .ant-skeleton-element .ant-skeleton-input {
    height: 18px;
    border-radius: 4px;
  }
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.globalWhite100};
    border: 1px solid ${theme.colors.neutralSilver20};
    border-radius: 8px;
  `}
`;

export const Row = styled.div`
  ${({ theme }) => css`
    width: 100%;
    padding: 0 16px;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.neutralSilver10};
    }
  `}
`;

export const FirstPaymentSection = styled.div`
  display: grid;
  grid-template-columns: 2fr auto;
  align-items: center;
  margin: 32px 0 24px 0;
`;

export const FirstPayment = styled.div``;

export const Label = styled.p`
  ${({ theme }) => css`
    font-size: 1.2rem;
    color: ${theme.colors.neutralSilver60};
    line-height: 1.6;
  `}
`;

export const FirstPaymentValue = styled.p`
  ${({ theme }) => css`
    font-size: 2.4rem;
    line-height: 2.9rem;
    font-weight: 700;
    color: ${theme.colors.neutralGray100};

    &::after {
      vertical-align: bottom;
      font-size: 2rem;
      line-height: 2.8rem;
      font-weight: 400;
    }
  `}
`;

export const DetailsSection = styled.div`
  margin: 12px 0 8px 0;
`;

export const DetailsTitle = styled.h3`
  ${({ theme }) => css`
    font-size: 1.8rem;
    font-weight: 500;
    color: ${theme.colors.neutralSilver60};
    margin-bottom: 4px;
  `}
`;

export const DetailsText = styled.p`
  ${({ theme }) => css`
    font-size: 1.6rem;
    color: ${theme.colors.neutralGray100};

    > span {
      color: ${theme.colors.neutralSilver50};
    }

    > strong {
      font-weight: 400;
    }
  `}
`;

export const AfterCreditVoucher = styled.div`
  ${({ theme }) => css`
    width: 100%;
    border-top: 1px solid ${theme.colors.neutralSilver10};
    margin-top: 8px;
    padding-top: 8px;
  `}
`;

export const Info = styled.ul`
  list-style: none;
  margin: 12px 0;
`;

export const Item = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const Text = styled.p<TextProps>`
  ${({ theme, color = 'neutralSilver60' }) => css`
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 400;
    color: ${theme.colors[color]};

    span {
      color: ${theme.colors.neutralSilver50};
    }

    &:nth-child(even) {
      text-align: right;
    }
  `}
`;

export const Disclaimer = styled.p`
  ${({ theme }) => css`
    font-size: 1.2rem;
    font-style: italic;
    color: ${theme.colors.neutralSilver70};
    line-height: 1.6;
    text-align: center;
    margin: 12px 0;
  `}
`;
